// extracted by mini-css-extract-plugin
export var activityContainer = "_if-0";
export var typingIndicatorContainer = "_if-1";
export var typingIndicatorDot = "_if-2";
export var wave = "_if-3";